// extracted by mini-css-extract-plugin
export default {"OurTeam":"ourteam_OurTeam__zsfeo","teammateContainer":"ourteam_teammateContainer__z-N-M","teamMarquee":"ourteam_teamMarquee__CCTGy","teammate":"ourteam_teammate__SFo1f"};